import React from "react";
import PropTypes from "prop-types";
// import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const AnnotationSnackbar = props => {
  const filesList = props.soloSuccessfulAnnotations.map((x, i) => {
    if (props.soloSuccessfulAnnotations.length - 1 === i)
      return <span>{x}</span>;
    return (
      <span>
        {x}
        <br />
      </span>
    );
  });
  const fileNum = ` ${props.soloSuccessfulAnnotations.length} `;
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      open={props.soloAnnotationSnackbarOpen}
      autoHideDuration={15000}
      onClose={props.onSoloAnnotationSnackbarClose}
      ContentProps={{
        "aria-describedby": "message-id"
      }}
      message={
        <span id="message-id">
          You successfully annotated
          {fileNum}
          file(s):
          <br />
          {filesList}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          // className={classes.close}
          onClick={props.onSoloAnnotationSnackbarClose}
        >
          <CloseIcon />
        </IconButton>
      ]}
    />
  );
};

AnnotationSnackbar.propTypes = {
  soloAnnotationSnackbarOpen: PropTypes.bool.isRequired,
  onSoloAnnotationSnackbarClose: PropTypes.func.isRequired,
  soloSuccessfulAnnotations: PropTypes.arrayOf(PropTypes.string)
};

AnnotationSnackbar.defaultProps = {
  soloSuccessfulAnnotations: []
};

export default AnnotationSnackbar;
